import {
  SET_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS,
  DISPLAY_SQUAD_CHANGE_MODAL_FOR_CAPTAIN,
  SET_ROSTER_WARNINGS_FOR_CAPT_ENTRY_DETAIL,
  DISPLAY_EVENT_CHANGE_MODAL_FOR_CAPTAIN
} from './constants';

export const initialState = {
  paymentLog: {},
  virtualEntriesToModify: [],
  showSquadChangeModal: false,
  showEventChangeModal: false
};

export const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case DISPLAY_SQUAD_CHANGE_MODAL_FOR_CAPTAIN: {
      return {
        ...state,
        showSquadChangeModal: payload
      };
    }
    case SET_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS:
      return {
        ...state,
        paymentLog: payload
      };
    case SET_ROSTER_WARNINGS_FOR_CAPT_ENTRY_DETAIL:
      return {
        ...state,
        virtualEntriesToModify: payload || initialState.virtualEntriesToModify
      };
    case DISPLAY_EVENT_CHANGE_MODAL_FOR_CAPTAIN: {
      return {
        ...state,
        showEventChangeModal: payload
      };
    }
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/registration/manage/reducer.js